import { FC, useEffect, useState } from "react";
import { Stack, Typography } from "@mui/material";
import { GridApi } from "ag-grid-community";
import { useTotalInHeaderCalculator } from "@/components/pages/common/ag-grid/utils/hooks/useTotalInHeaderCalculator.hook";
import { SavingsOpportunity } from "@/services/cloudchipr.api";

interface SavingsOpportunitiesCountProps {
  gridApi: GridApi | null;
}

export const OpportunitiesCount: FC<SavingsOpportunitiesCountProps> = ({
  gridApi,
}) => {
  const [selectionCount, setSelectionCount] = useState(0);

  const itemsCount = useTotalInHeaderCalculator<SavingsOpportunity>(
    gridApi,
    (data) => data.id,
    "uniquesCount",
  );

  useEffect(() => {
    setSelectionCount(gridApi?.getSelectedRows()?.length ?? 0);

    gridApi?.addEventListener("rowSelected", (event) => {
      setSelectionCount(event?.api?.getSelectedRows()?.length ?? 0);
    });
    gridApi?.addEventListener("rowDataUpdated", (event) => {
      setSelectionCount(event?.api?.getSelectedRows()?.length ?? 0);
    });
  }, [gridApi]);

  return (
    <Stack
      direction="row"
      spacing={1}
      divider={
        <Typography variant="body2" color="text.secondary">
          |
        </Typography>
      }
    >
      {!!itemsCount && (
        <Typography variant="body2">{itemsCount} Opportunities</Typography>
      )}

      {!!selectionCount && (
        <Typography variant="body2" color="text.secondary">
          {selectionCount} selected
        </Typography>
      )}
    </Stack>
  );
};
